import React from 'react'

const AiImportPriceList = () => {
  return (
    <div>AiImportPriceList</div>
  )
}

export default AiImportPriceList